<mat-dialog-content>
  <div class="row" [formGroup]="shipmentForm">
    <div class="col-12 text-end icon-mat-button">
      <i mat-dialog-close class="bi bi-x"></i>
    </div>

    <div class="col-12 d-flex align-items-baseline justify-content-between">
      <div class="">
        <h4>{{ 'address.addressEmail.addEmailAddress' | translate }}</h4>
      </div>
      <div class="form-group">
        <button
          class="me-1 icon-mat-button"
          (click)="addMsg()"
          #tooltip="matTooltip"
          matTooltip="{{ 'address.addressEmail.toolTip.createPreAlert' | translate }}"createPreAlert
          mat-raised-button>
          <em class="bi bi-plus"></em>
        </button>
      </div>
    </div>

    <div class="table-container">
      <ng-container formArrayName="preAlertEmails">
        <table aria-describedby="pieceData-table" mat-table [dataSource]="alertPieceDataSource">
          <ng-container matColumnDef="receiverNo">
            <th id="receiverNo" mat-header-cell *matHeaderCellDef>{{ 'global.no' | translate }}</th>
            <td mat-cell class="text-center" *matCellDef="let row; let i = index" [formGroup]="row">
              <input
                style="display: none"
                class="form-control"
                formControlName="pieceNo"
                value="i+1" />
              <label>{{ i + 1 }}.</label>
            </td>
          </ng-container>

          <ng-container matColumnDef="receiverId">
            <th id="receiverId" mat-header-cell *matHeaderCellDef>
              {{ 'address.addressEmail.emailId' | translate }}
            </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <input formControlName="receiverId" class="form-control" type="text" [email]="true" />
            </td>
          </ng-container>

          <ng-container matColumnDef="bespokeMessage">
            <th id="bespokeMessage" mat-header-cell *matHeaderCellDef>
              {{ 'address.addressEmail.message' | translate }}
            </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <input formControlName="bespokeMessage" class="form-control" type="text" />
            </td>
          </ng-container>

          <ng-container matColumnDef="Action">
            <th id="action" mat-header-cell *matHeaderCellDef>{{ 'global.action' | translate }}</th>
            <td mat-cell *matCellDef="let row; let i = index">
              <i
                matTooltip="{{ 'address.addressEmail.toolTip.delete' | translate }}"
                (click)="deleteRow(i)"
                class="m-1 text-center icon-mat bi bi-trash"></i>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="alertColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: alertColumns"></tr>

          <tr class="mat-row justify-content-center" *matNoDataRow>
            {{
              'global.noDataAvailable' | translate
            }}
          </tr>
        </table>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <p *ngIf="this.preAlertEmails().length > 0 && !disableSave()" class="alert-msg">
    {{ 'address.addressEmail.clickOnUpdate' | translate }}
  </p>
  <button [disabled]="disableSave()" class="primary-btn" (click)="savePreAlertEmail()">{{'global.ok' |
    translate}}</button>
</mat-dialog-actions>
